module.exports = __webpack_public_path__ + "img/rise.bb35f07c.svg";